import Main from "./views/Main";
import AuthProvider from "./providers/auth/AuthProvider";
import { ToastProvider } from "./providers/ToastProvider";
import { SpeciesProvider } from "./providers/SpeciesProvider";
import { CourseCategoryProvider } from "./providers/CourseCategoryProvider";
import { CourseProvider } from "./providers/CourseProvider";
import { TrainerProvider } from "./providers/TrainerProvider";

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <SpeciesProvider>
          <CourseCategoryProvider>
            <TrainerProvider>
              <CourseProvider>
                <Main />
              </CourseProvider>
            </TrainerProvider>
          </CourseCategoryProvider>
        </SpeciesProvider>
      </ToastProvider>
    </AuthProvider>
  );
}
